import {Component, ElementRef, NgZone, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {FasterqLineModel} from "../../../models/fasterq-line-model";
import {dateToday, HOST_DIR, isNullOrUndef, validateEmail} from "../../../common";
import {ToastrService} from "ngx-toastr";
import {ActivatedRoute} from "@angular/router";
import {catchError, filter, map, switchMap, take} from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import {IAppStatic} from "../../../interfaces";
import {LocalStoreService, StoreSelectorsService} from "../../../services";
import {actionFasterqLoadedLine, actionFasterqLoadTerminalLine} from "../../../store/actions/fasterq.actions";
import {NgxFlickingComponent} from "@egjs/ngx-flicking";
import {TranslocoService} from "@ngneat/transloco";
import {MatDialog} from "@angular/material/dialog";
import {Lib} from "../../../../libs/Lib";
import {ajax} from "rxjs/ajax";
import {of, timer} from "rxjs";
import * as _ from 'lodash';
import {once} from "../../../decorators/once-decorator";

declare let RC4V2: any;

@Component({
    selector: 'app-fasterq-lines',
    templateUrl: './fasterq-terminal-component.html',
    styleUrls: ['./fasterq-terminal-component.scss']
})
export class FasterqTerminalComponent extends Compbaser implements OnInit {
    plugins = [];
    qrValue = '';
    m_fasterqLineModel: FasterqLineModel;
    m_displayServiceId = '';
    emailAddress = '';
    m_appMode = '';
    sms = '';
    m_statusHandler;
    m_currentlyServing = 0;
    m_printing = false;
    m_serviceId = 0;
    m_lineName = '';
    appSettings: IAppStatic;
    devMode;
    user = '';
    password = '';

    @ViewChild(NgxFlickingComponent) flick: NgxFlickingComponent;
    @ViewChild('printArea') el: ElementRef;

    constructor(public override dialog: MatDialog,
                private storeSelector: StoreSelectorsService,
                private localStoreService: LocalStoreService,
                private http: HttpClient,
                private router: ActivatedRoute,
                private toastr: ToastrService) {
        super(dialog);
        this.devMode = Lib.DevMode();
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        );
        this.cod(
            this.storeSelector.getFasterqTerminal()
                .pipe(filter(v => !_.isNull(v)))
                .subscribe((i_fasterqLineModel: FasterqLineModel) => {
                    if (this.m_appMode === '') return;
                    this.m_fasterqLineModel = i_fasterqLineModel;
                    switch (this.m_appMode) {
                        case 'CUSTOMER_TERMINAL': {
                            this._createQRcode();
                            break;
                        }
                        case 'REMOTE_STATUS': {
                            this._getServerDateTime();
                            break;
                        }
                        default: {
                            console.log('fasterq problem, did not get line id');
                        }
                    }
                }, (e) => console.error(e))
        );
    }

    ngOnInit() {
        this.cod(
            this.router.params.pipe(take(1))
                .subscribe(i_params => {
                    let data;
                    if (i_params.term) {
                        /** Terminal mode, coming from Studio link **/
                        const rc = Lib.DecryptValue(i_params.term);
                        data = JSON.parse(rc);
                        this.m_appMode = 'CUSTOMER_TERMINAL';
                        this.user = data.u;
                        this.password = data.p;
                        this.storeSelector.dispatch(actionFasterqLoadTerminalLine({
                            payload: {
                                line_id: data.l,
                                business_id: data.d,
                                user: this.user,
                                password: this.password
                            }
                        }));
                    } else {
                        /** Remote status mode, coming server short url **/
                        const a = i_params.state.replace(/!/ig, '\+');
                        const b = atob(a);
                        const c = JSON.parse(b);
                        this.m_appMode = 'REMOTE_STATUS';
                        this.storeSelector.dispatch(actionFasterqLoadedLine({
                            payload: new FasterqLineModel(c)
                        }));
                    }
                }, (e) => console.error(e))
        );
    }

    async go(val) {
        if (isNullOrUndef(val)) return;

        try {
            await this.flick.moveTo(val);
        } catch (err) {
            console.log(err);
        }
    }

    _getServerDateTime() {
        this.cod(
            ajax({
                url: `${this.appSettings.globalService}/GetDateTime`,
                method: ('GET'),
                crossDomain: true,
                body: {},
                headers: {contentType: "application/json"}
            }).pipe(
                map(e => e.response),
                catchError(error => {
                    return of({
                        type: 'GetDateTime',
                        payload: error.xhr.response,
                        error: true
                    });
                }),
                take(1)
            ).subscribe((i_response) => {
                this._initServices(i_response);
            })
        );
    }

    _initServices(i_dateTime) {
        // this.localStoreService.removeItem('FASTERQ'); // test
        const storage = this.localStoreService.getItem('FASTERQ');
        if (!_.isUndefined(storage) && !this.m_fasterqLineModel) {
            const storedDate = storage.date;
            if (storedDate != i_dateTime.date) {
                this.localStoreService.removeItem("FASTERQ");
            } else {
                this.m_fasterqLineModel = new FasterqLineModel(storage);
                this.initGetNowServicing();
                return;
            }
        }
        const call_type = this.m_fasterqLineModel.callType;
        if (call_type == 'SMS' || call_type == 'EMAIL') {
            if (i_dateTime.date != this.m_fasterqLineModel.date) {
                this.toastr.info('your number expired on ' + this.m_fasterqLineModel.date + ', so we generated a new number for you...');
                this._getServiceID();
                return;
            }
            this._createStorage(this.m_fasterqLineModel);
            this.initGetNowServicing();
        }

        if (call_type == 'QR') {
            this._getServiceID();
        }
    }

    _createStorage(model: FasterqLineModel) {
        const d = model.getDataToJS();
        this.localStoreService.setItem('FASTERQ', d);
    }

    _getNewSpot() {
        return super.openDialog('are you sure you want to get a new number?', {showCancel: true}, (r) => {
            if (r) {
                this.localStoreService.removeItem('FASTERQ');
                window.clearInterval(this.m_statusHandler);
                const url = this._buildURL();
                window.location.replace(url);
            }
        });
    }

    _releaseSpot() {
        return super.openDialog('are you sure you want to let go of your spot?', {showCancel: true}, (r) => {
            if (r) {
                this.toastr.info('have a nice day');
                this.localStoreService.removeItem('FASTERQ');
                window.clearInterval(this.m_statusHandler);
                this.m_appMode = '';
            }
        });
    }

    _getServiceID() {
        const options = {
            line_id: this.m_fasterqLineModel.lineId,
            business_id: this.m_fasterqLineModel.businessId,
            email: this.m_fasterqLineModel.email,
            call_type: this.m_fasterqLineModel.callType,
        };
        const url = `${this.appSettings.globalService}/Queue`;
        return this.http.post(url, options)
            .pipe(
                catchError((err) => {
                    console.log(err);
                    return err;
                }),
                take(1))
            .subscribe((i_response: Response) => {
                const fasterqLineModel: FasterqLineModel = new FasterqLineModel(i_response);
                this._createStorage(fasterqLineModel);
                this.storeSelector.dispatch(actionFasterqLoadedLine({payload: fasterqLineModel}));
                this.initGetNowServicing();
            }, (e) => console.error(e));
    }

    @once
    initGetNowServicing() {
        this.cod(
            timer(333, 5000).pipe(
                switchMap(v => {
                    return ajax({
                        url: `${this.appSettings.globalService}/LastCalledQueue`,
                        method: ('POST'),
                        crossDomain: true,
                        body: {
                            business_id: this.m_fasterqLineModel.businessId,
                            line_id: this.m_fasterqLineModel.lineId
                        },
                        headers: {contentType: "application/json"}
                    }).pipe(
                        map(e => e.response),
                        catchError(error => {
                            return of({
                                type: 'Queue',
                                payload: error.xhr.response,
                                error: true
                            });
                        })
                    );
                })
            ).subscribe((i_model: any) => {
                this.m_currentlyServing = i_model.service_id;
            })
        );
    }

    _createQRcode() {
        this.qrValue = this._buildURL();
    }

    _onCall($event) {
        const baseUrl = Lib.DevMode() ? `${this.appSettings.localhost}/shopping-cart/fasterq/status/` : `${this.appSettings.protocol}${this.appSettings.masterServer}/${HOST_DIR}/shopping-cart/fasterq/status/`;
        if (this.sms.length < 6)
            return this.toastr.error('The phone number entered is invalid');
        const body = {
            business_id: this.m_fasterqLineModel.businessId,
            line_id: this.m_fasterqLineModel.lineId,
            line_name: this.m_fasterqLineModel.lineName,
            sms: this.sms,
            call_type: 'SMS',
            url: baseUrl
        };
        this.cod(
            ajax({
                url: `${this.appSettings.globalService}/SendQueueSMSEmail`,
                method: ('POST'),
                crossDomain: true,
                body,
                headers: {contentType: "application/json"}
            }).pipe(
                map(e => e.response),
                catchError(error => {
                    return of({
                        type: 'Queue',
                        payload: error.xhr.response,
                        error: true
                    });
                }),
                take(1)
            ).subscribe((i_response) => {
                this.toastr.info('Thank you');
                setTimeout(() => {
                    this.sms = '';
                }, 4000);
            })
        );
    }

    _onSend($event) {
        const baseUrl = Lib.DevMode() ? `${this.appSettings.localhost}/shopping-cart/fasterq/status/` : `${this.appSettings.protocol}${this.appSettings.masterServer}/${HOST_DIR}/shopping-cart/fasterq/status/`;
        if (!validateEmail(this.emailAddress)) return this.toastr.error('The email address entered is invalid');
        const body = {
            business_id: this.m_fasterqLineModel.businessId,
            line_id: this.m_fasterqLineModel.lineId,
            line_name: this.m_fasterqLineModel.lineName,
            email: this.emailAddress,
            call_type: 'EMAIL',
            url: baseUrl
        };
        this.cod(
            ajax({
                url: `${this.appSettings.globalService}/SendQueueSMSEmail`,
                method: ('POST'),
                crossDomain: true,
                body,
                headers: {contentType: "application/json"}
            }).pipe(
                map(e => e.response),
                catchError(error => {
                    return of({
                        type: 'Queue',
                        payload: error.xhr.response,
                        error: true
                    });
                }),
                take(1)
            ).subscribe((i_response: any) => {
                if (i_response?.error) return this.toastr.info('Sorry there was a problem adding your information');
                this.toastr.info('Thank you');
                setTimeout(() => {
                    this.emailAddress = '';
                }, 4000);
            })
        );
    }

    _onPrint(event) {
        const body = {line_id: this.m_fasterqLineModel.lineId, business_id: this.m_fasterqLineModel.businessId};
        const url = `${this.appSettings.globalService}/Queue`;
        this.cod(
            ajax({
                url,
                method: ('POST'),
                crossDomain: true,
                body,
                headers: {contentType: "application/json"}
            }).pipe(
                map(e => e.response),
                catchError(error => {
                    return of({
                        type: 'Queue',
                        payload: error.xhr.response,
                        error: true
                    });
                }),
                take(1)
            ).subscribe((i_response) => {
                const jData: any = i_response;
                this.m_displayServiceId = jData.service_id;
                this.m_serviceId = jData.service_id;
                this.m_lineName = jData.name;
                this.printElem(jData.service_id);
            })
        );
    }

    printElem(i_serviceId) {
        this.m_printing = true;
        const myWindow = window.open('', i_serviceId, 'height=400,width=600');
        setTimeout(() => {
            const printContents = this.el.nativeElement.innerHTML;
            const now = dateToday('MMMM Do YYYY, h:mm:ss a');
            // var myWindow = window.open('', self.selectedOrder.getDate(), 'height=400,width=600');
            myWindow.document.write(`<html><head><title>time: ${now}</title>`);
            /*optional stylesheet*/ //
            myWindow.document.write('</head><body >');
            // myWindow.document.write('<link rel="stylesheet" href="http://localhost:9089/src/styles/style.css" type="text/css" />');
            myWindow.document.write(printContents);
            myWindow.document.write('</body></html>');
            myWindow.document.close(); // necessary for IE >= 10
            myWindow.focus(); // necessary for IE >= 10
            myWindow.print();
            myWindow.close();
        }, 1000);
        setTimeout(() => {
            this.m_printing = false;
        }, 2000);
        return true;
    }

    _buildURL() {
        const data = {
            line_id: this.m_fasterqLineModel.lineId,
            business_id: this.m_fasterqLineModel.businessId,
            call_type: 'QR'
        };
        const data64 = btoa(JSON.stringify(data)).replace(/\+/ig, '!');
        // const data64 = Lib.RC4Encrypt(JSON.stringify(data));
        return Lib.DevMode() ? `${this.appSettings.localhost}/shopping-cart/fasterq/status/${data64}` : `${this.appSettings.protocol}${this.appSettings.masterServer}/${HOST_DIR}/shopping-cart/fasterq/status/${data64}`;
    }
}
